'use client';

import { useToggle } from '@mantine/hooks';
import { useState } from 'react';
import { SupplierProfileModal } from '../components';

export type UseSupplierProfileModal = {
  showSupplierProfileModal: (supplierId: string) => void;
  renderSupplierProfileModal: () => JSX.Element | null;
};

export const useSupplierProfileModal = (): UseSupplierProfileModal => {
  const [supplierId, setSupplierId] = useState<string>();
  const [show, toggleShow] = useToggle();

  const showSupplierProfileModal = (supplierId: string) => {
    setSupplierId(supplierId);
    toggleShow();
  };

  const closeSupplierProfileModal = () => {
    setSupplierId(undefined);
    toggleShow();
  };

  const renderSupplierProfileModal = () => {
    if (supplierId && show) {
      return (
        <SupplierProfileModal
          orgId={supplierId}
          show={show}
          close={closeSupplierProfileModal}
        />
      );
    }

    return null;
  };

  return { showSupplierProfileModal, renderSupplierProfileModal };
};
